import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {DataService} from 'shared/_services/data.service';
import {environment} from '../../../../src/environments/environment';

@Injectable({providedIn: 'root'})
export class EditModeService {
	private _enabled = false;

	constructor(private data: DataService) {}

	get isEnabled(): boolean {
		return this._enabled;
	}

	enable(): Observable<void> {
		if (this._enabled) return of(void 0);
		return this.data.post('api/users/enable-edit', {}).pipe(
			tap(() => this._enabled = true),
			map(() => void 0),
			catchError(() => {
				this._enabled = false;
				return of(void 0);
			})
		);
	}

	disable(): Observable<void> {
		if (!this._enabled) return of(void 0);
		return this.data.post('api/users/disable-edit', {}).pipe(
			tap(() => this._enabled = false),
			map(() => void 0),
			catchError(() => {
				this._enabled = false;
				return of(void 0);
			})
		);
	}

	forceDisable(): Observable<void> {
		return this.data.post('api/users/disable-edit', {}).pipe(
			tap(() => this._enabled = false),
			map(() => void 0),
			catchError(() => {
				this._enabled = false;
				return of(void 0);
			})
		);
	}

	disableViaBeacon(): void {
		if (!this._enabled) return;
		const url = `${environment.apiUrl}/api/users/disable-edit`;
		if (navigator.sendBeacon) {
			navigator.sendBeacon(url, '{}');
		}
		this._enabled = false;
	}
}
